import React from "react";
import { compose } from "redux";
import withLocalization from "../../../hoc/with-localization";
import { connect } from "react-redux";
import { ReactComponent as Logo } from "../logo.svg";
import setTheme from "../../../utils/setTheme";
import "./reference-page.scss";
import referenceData from "../../../reference-data.json";
import pack from "../../../../package.json";
import getUrls from "../../../api";

const ReferencePage = ({ theme, loc, anonymousMode, basepath }) => {
    const { company, product, registrationCertificate, technicalSupport } = referenceData;
    setTheme(theme);
    const Phones = technicalSupport.phones.map(_ph => (
        <span key={_ph.number}>
            <a href={"tel:" + _ph.number}>{_ph.display}</a>
            <span>, </span>
        </span>
    ));
    const { originPath } = getUrls(basepath);
    const userGuide = originPath + "api/docs/";

    return (
        <div className="reference-page">
            <div className="reference-page__content">
                <div className="reference-page__logo-container">
                    <Logo />
                </div>
                <h1 className="reference-page__mainTitle">Справка</h1>
                <h2 className="reference-page__title">Наименование предприятия-изготовителя</h2>
                <p className="reference-page__text">
                    {company.nameFull}
                    <br />
                    {company.nameShort}
                </p>
                <h2 className="reference-page__title">Наименование медицинского изделия</h2>
                <p className="reference-page__text">
                    Программное обеспечение &quot;{product.programName}&quot;
                    <br />
                    Разработано в соответствии с ТУ {product.specification}
                </p>

                <h2 className="reference-page__title">Номер и дата регистрационного удостоверения</h2>
                <p className="reference-page__text">
                    № {registrationCertificate.number} от {registrationCertificate.date}
                </p>

                <h2 className="reference-page__title">Контактные данные предприятия-изготовителя и службы технической поддержки</h2>
                <p className="reference-page__text">
                    {company.address}
                    <br />
                    Тел.: {Phones}
                    <br />
                    Электронная почта: <a href={"mailto:" + technicalSupport.email}>{technicalSupport.email}</a> <br />
                    Сайт: <a href={technicalSupport.site}>{technicalSupport.site}</a>
                </p>

                <h2 className="reference-page__title">Номер версии программного обеспечения</h2>
                <p className="reference-page__text">
                    {`${loc("version")}`} {product.programVersion}
                    {anonymousMode ? null : <span> (frontend {pack.version})</span>}
                </p>

                <h2 className="reference-page__title"> Руководство пользователя</h2>
                <p className="reference-page__text">
                    <a target="_blank" href={userGuide} rel="noreferrer">
                        Скачать PDF
                    </a>
                </p>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    const {
        reportApp: {
            app: { settings }
        }
    } = state;
    return {
        lang: settings.lang,
        theme: settings.theme
    };
};

export default compose(withLocalization, connect(mapStateToProps))(ReferencePage);
